const productTypesArray = [];

class ProductTypes {
  constructor(options) {
    this.endpoint = options.endpoint;
  }

  fetchData() {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('GET', this.endpoint);
      xhr.onload = () => {
        if (xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
          const response = JSON.parse(xhr.responseText);
          const productTypes = response.worldwide_product_types || [];

          productTypes.forEach((entry, i) => {
            productTypesArray[i] = entry;
          });

          resolve(productTypesArray);
        }
      };
      xhr.onerror = () => reject(xhr.statusText);
      xhr.send();
    });
  }
}

export default ProductTypes;
